<template>
<div class="box">
  <p class="string" v-for="(item, index) in findable.value" :key="index">
    {{ item }}
  </p>
</div>  
</template>
<script>
export default {
  
  props: {
    findable: {
      type: Object,
      default: () => ({})
    }
  }

}
</script>